
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartScaleBoundariesIec as ObiChartScaleBoundariesIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-scale-boundaries-iec.js';
 
 
 

 
 export const ObiChartScaleBoundariesIec = createComponent({
   react: React,
   tagName: 'obi-chart-scale-boundaries-iec',
   elementClass: ObiChartScaleBoundariesIecElement,
   events: {
     
   }
  });
 
 